import React from "react";

const Hero = () => {
  return (
    <div className="text-center py-24 lg:py-32 relative">
      <h1 className="text-4xl lg:text-6xl xl:text-7xl lg:tracking-[-6px] font-popinsBold text-themeColor">
        Contact Us – Let’s Elevate Your
        <br />
        <span className="text-btnColor mt-[-10px]">Management Experience</span>
      </h1>
      <p className="font-popinsRegular text-lg text-textColor w-[90%] lg:w-[45%] mx-auto leading-6 pt-4">SeamLessly unlock smarter living let Flex Management Systems take the hassle out of property management.</p>
      <div className="absolute left-0 bottom-10 size-56">
        <img src="/assets/hero.png" alt="" className="size-full object-fill" />
      </div>
    </div>
  );
};

export default Hero;
